import { WebViewerInstance } from '@pdftron/webviewer';
import { AllDocumentTypes } from 'types';

// True when the viewer instance exists and its document has finished loading. A disposed viewer is
// still an object, so a plain null check passes and then PDFTron throws on first use.
export const hasLoadedDocument = (instance: WebViewerInstance | null | undefined): instance is WebViewerInstance => {
  if (!instance) return false;
  return Boolean(instance.Core.documentViewer.getDocument());
};

// Add a css class to a web viewer
export const addWebViewerClass = (documentType: AllDocumentTypes, className: string) => {
  const viewer = getWebViewerElement(documentType);
  viewer?.classList.add(className);
};

// Remove a css class from a web viewer
export const removeWebViewerClass = (documentType: AllDocumentTypes, className: string) => {
  const viewer = getWebViewerElement(documentType);
  viewer?.classList.remove(className);
};

// Returns the `apryse-webviewer` web component for a given document type
export const getWebViewerElement = (documentType: AllDocumentTypes) => {
  return document?.querySelector(`apryse-webviewer.${documentType}-viewer`);
};

// For when you need to access elements within the web viewer shadow dom
export const getWebViewerShadowRoot = (documentType: AllDocumentTypes) => {
  const viewer = getWebViewerElement(documentType);
  return viewer?.shadowRoot;
};
